export default __webpack_public_path__ + "static/media/1777.27e2d855.png";